import { OrderLineModel } from '@onrunning/backstage-models';

export class OrderProduct extends OrderLineModel {
  public productGroupId: string;

  // transient
  public modified: boolean;
  public quantityBeforeUpdate?: number;
}
